import React, { Fragment, Component } from 'react'
import {Link} from 'react-router-dom'
import { Carousel } from 'antd'

class LunboFirst extends Component {
  constructor(props){
    super(props);
    this.state = {
      current: 0
    }
    this.lunboChange = this.lunboChange.bind(this)
  }
  render() {
    return (
      <Fragment>
        <div className='border flex-row-between center960' >
          <div className='lunbo-first-img'>
            <Carousel autoplay dotPosition='bottom' afterChange={this.lunboChange}>
              {this.props.lunbo.map((item,index)=>{
                return(<img src={item.picurl} alt='pic' key={index} />)
              })}
            </Carousel>
          </div>
            <div className='m1desc'>
              <div className='m1topic'>{this.props.lunbo[this.state.current].topic}</div>
              <div className='m1text'>{this.props.lunbo[this.state.current].ad}</div>
              <div className='m1text'><Link to={this.props.lunbolink + "/" + this.state.current}>点击浏览</Link></div>
              <div className='m1text m1topspace'><Link to={this.props.lunbolink}>查看更多...</Link></div>
            </div>
        </div>
      </Fragment>
    )
  }
  lunboChange(current){
    this.setState({
      current: current
    })
  }
}

export default LunboFirst
